import React from 'react'

const Administered = () => {
  return (
    <svg
      aria-hidden="true"
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5896 0.460121C13.8524 0.754826 14 1.15448 14 1.57119C14 1.9879 13.8524 2.38755 13.5896 2.68226L6.58082 10.5399C6.31796 10.8345 5.96148 11 5.58979 11C5.21809 11 4.86161 10.8345 4.59875 10.5399L0.393488 5.82531C0.138148 5.52891 -0.00314079 5.13194 5.29899e-05 4.71989C0.00324677 4.30785 0.150668 3.91369 0.410564 3.62231C0.67046 3.33094 1.02204 3.16566 1.38957 3.16208C1.75711 3.1585 2.11119 3.3169 2.37557 3.60317L5.58979 7.20668L11.6075 0.460121C11.8704 0.165506 12.2269 0 12.5985 0C12.9702 0 13.3267 0.165506 13.5896 0.460121Z"
        fill="#37A598"
      />
    </svg>
  )
}

export default Administered
